import React, { useEffect, useState } from 'react';
import { CreateFlowModal } from './CreateFlowModal';
import { ModalContent } from './shared/FormComponents';
import { CreateFlowBackButton } from './shared/CreateFlowBackButton';
import { SmartCreateForm } from './shared/SmartCreateForm';
import { DifficultyLevel } from './shared/SmartCreateForm';
import useCreateSmartCourse from 'hooks/useCreateSmartCourse';
import { Redirect } from 'react-router-dom';
import { AnalyticsService } from 'utils/AnalyticsService';

interface IProps {
  onClose: () => void;
  onBack: () => void;
}


export const SmartCreateCourseModal = (props: IProps) => {
  const { onClose, onBack } = props;
  const [topic, setTopic] = useState<string>('');
  const [difficulty, setDifficulty] = useState<DifficultyLevel>('Beginner');
  const [pdfFile, setPdfFile] = useState<File | null>(null);

  const [createSmartCourse, { status: creationStatus, data: responseData }] = useCreateSmartCourse();
  const course = responseData;

  useEffect(() => {
    if (creationStatus === 'success' && course?.id) {
      AnalyticsService.getInstance().track('creation_completed', {
        creation_type: 'course',
        creation_method: 'smart_create',
      });
    }
  }, [creationStatus, course?.id]);

  const handleGenerateCourse = async () => {
    if (!topic.trim()) return;

    try {
      const payload: any = {
        title: topic,
        level: difficulty,
        language: 'English' // Default to English for now
      };

      // Add PDF file if provided
      if (pdfFile) {
        payload.pdf_file = pdfFile;
      }

      await createSmartCourse(payload);
      
      // Navigation to course detail page will happen via Redirect component
    } catch (error) {
      console.error('Error generating smart course:', error);
      // TODO: Show error message to user
    }
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && file.type === 'application/pdf') {
      setPdfFile(file);
    }
  };
  const isGenerating = creationStatus === 'loading';

  // Redirect to course detail page after successful creation
  if (creationStatus === 'success' && course?.id) {
    return (
      <Redirect
        to={{
          pathname: `/nav/courses/${course.id}`,
        }}
      />
    );
  }

  return (
    <CreateFlowModal title="Create Course (Smart Create)" onClose={onClose}>
      <ModalContent>
        <CreateFlowBackButton onClick={onBack} />

        <SmartCreateForm
          topic={topic}
          difficulty={difficulty}
          pdfFile={pdfFile}
          onTopicChange={setTopic}
          onDifficultyChange={setDifficulty}
          onFileUpload={handleFileUpload}
          onSubmit={handleGenerateCourse}
          isCreating={isGenerating}
          submitButtonText="Generate Course"
          topicPlaceholder="E.g. Introduction to Machine Learning"
        />
      </ModalContent>
    </CreateFlowModal>
  );
};

